import React, {FC} from "react";
import {FeOrder} from "../redux/types";
import {theme} from "../../../theme";
import {isAfter} from "date-fns";
import {Chip, ChipProps} from "@material-ui/core";

interface OrderStatusChipProps {
    order: FeOrder;
    chipProps?: ChipProps;
}

type StatusProps = {
    name: string;
    color: string;
}

export const statusMap: { [key: string]: StatusProps } = {
    unconfirmed: {
        name: "Unbestätigt",
        color: theme.palette.warning.light
    },
    confirmed: {
        name: "Geplant",
        color: theme.palette.warning.light
    },
    hasHappened: {
        name: "Stattgefunden",
        color: theme.palette.error.light
    },
    finalized: {
        name: "Beendet",
        color: theme.palette.success.light
    },
    canceled: {
        name: "Abgesagt",
        color: theme.palette.error.main
    }

}

export const getOrderStatusProps = (order: FeOrder): StatusProps => {
    if (order.cancellation) {
        return statusMap.canceled;
    }
    if (order.confirmed) {
        if (order.from && order.to) {
            return statusMap.finalized
        } else {
            if (isAfter(new Date(), order.estimatedTo)) {
                return statusMap.hasHappened
            }
        }
        return statusMap.confirmed;
    } else {
        return statusMap.unconfirmed
    }
}

export const OrderStatusChip: FC<OrderStatusChipProps> = ({order, chipProps}) => {
    const {color, name} = getOrderStatusProps(order);
    return (
        <Chip
            {...chipProps}
            label={name}
            style={{backgroundColor: color, ...chipProps?.style}}
        />
    );
}
